<ng-container *ngIf="rule === null" i18n>Please click on the pencil to the right to create a rule</ng-container>
<ng-container *ngIf="rule !== null">
  <ng-container [ngSwitch]="rule.className">
    <eas-editor-eligibility-rule-value-has-role *ngSwitchCase="'HasRole'"
      [rule]="rule"
      [affirmative]="affirmative"
    >
    </eas-editor-eligibility-rule-value-has-role>
    <eas-editor-eligibility-rule-value-has-date-user-field *ngSwitchCase="'HasDateUserField'"
      [rule]="rule"
      [affirmative]="affirmative"
    >
    </eas-editor-eligibility-rule-value-has-date-user-field>
    <eas-editor-eligibility-rule-value-has-discrete-user-field *ngSwitchCase="'HasDiscreteUserField'"
      [rule]="rule"
      [affirmative]="affirmative"
    >
    </eas-editor-eligibility-rule-value-has-discrete-user-field>
    <eas-editor-eligibility-rule-value-has-string-user-field *ngSwitchCase="'HasStringUserField'"
      [rule]="rule"
      [affirmative]="affirmative"
    >
    </eas-editor-eligibility-rule-value-has-string-user-field>
    <eas-editor-eligibility-rule-value-has-relation *ngSwitchCase="'HasRelation'"
      [rule]="rule"
      [affirmative]="affirmative"
    >
    </eas-editor-eligibility-rule-value-has-relation>
    <eas-editor-eligibility-rule-value-has-booking-item *ngSwitchCase="'HasBookingItem'"
      [rule]="rule"
      [affirmative]="affirmative"
    >
    </eas-editor-eligibility-rule-value-has-booking-item>
    <eas-editor-eligibility-rule-value-has-booking-option *ngSwitchCase="'HasBookingOption'"
      [rule]="rule"
      [affirmative]="affirmative"
    >
    </eas-editor-eligibility-rule-value-has-booking-option>
    <eas-editor-eligibility-rule-value-has-booking-type *ngSwitchCase="'HasBookingType'"
      [rule]="rule"
      [affirmative]="affirmative"
    >
    </eas-editor-eligibility-rule-value-has-booking-type>
    <eas-editor-eligibility-rule-value-has-event *ngSwitchCase="'HasEvent'"
      [rule]="rule"
      [affirmative]="affirmative"
    >
    </eas-editor-eligibility-rule-value-has-event>
    <eas-editor-eligibility-rule-value-has-event-count *ngSwitchCase="'HasEventCount'"
      [rule]="rule"
      [affirmative]="affirmative"
    >
    </eas-editor-eligibility-rule-value-has-event-count>
    <eas-editor-eligibility-rule-value-is-raw-operator *ngSwitchCase="'IsRawOperator'"
      [rule]="rule"
      [affirmative]="affirmative"
    >
    </eas-editor-eligibility-rule-value-is-raw-operator>
  </ng-container>
</ng-container>
